// Router + auth gating. SignedIn/SignedOut from Clerk drive whether the
// shell or the sign-in flow shows. We do not redirect on every render —
// /sign-in renders the Clerk SignIn component directly so deep-linking
// to e.g. /agents while signed out lands on the sign-in page once.

import { Navigate, Route, Routes } from 'react-router-dom';
import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { AppProviders } from '../lib/providers.js';
import { AppShell } from '../components/layout/app-shell.js';
import { HomePage } from './home.js';
import { SignInPage } from './sign-in.js';
import { SignUpPage } from './sign-up.js';
import { AgentsListPage } from './agents/list.js';
import { AgentEditPage, AgentNewPage } from './agents/edit.js';
import { ApiKeysListPage } from './api-keys/list.js';
import { ConversationsListPage } from './conversations/list.js';
import { UsagePage } from './usage/page.js';
import { BillingPage } from './billing/page.js';
import { BillingUpgradePage } from './billing/upgrade.js';
import { AuditLogPage } from './audit/page.js';
import { SupportListPage } from './support/list.js';

export function AppRouter() {
  return (
    <Routes>
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route
        path="/*"
        element={
          <>
            <SignedOut>
              <Navigate to="/sign-in" replace />
            </SignedOut>
            <SignedIn>
              <AppProviders>
                <AppShell />
              </AppProviders>
            </SignedIn>
          </>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="agents" element={<AgentsListPage />} />
        <Route path="agents/new" element={<AgentNewPage />} />
        <Route path="agents/:id" element={<AgentEditPage />} />
        <Route path="api-keys" element={<ApiKeysListPage />} />
        <Route path="usage" element={<UsagePage />} />
        <Route path="conversations" element={<ConversationsListPage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="billing/upgrade" element={<BillingUpgradePage />} />
        <Route path="audit" element={<AuditLogPage />} />
        <Route path="support" element={<SupportListPage />} />
      </Route>
    </Routes>
  );
}
